// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"581797fc","135":"ec62f7de","140":"94abe37d","166":"9fd34bdf","191":"f9548b81","273":"169d0ae9","341":"ac9fe272","367":"fae5d10d","453":"3e2f02af","646":"f30e3b74","733":"7f93cca2","981":"b89bb6ab"}[chunkId] + ".chunk.js";
};